import React, { useState } from 'react';
import styles from './MethodChooser.module.css';
import { Radio, RadioGroup } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MethodChooser = ({ selectedMethod = null, onMethodChange = () => {}, shopTier, currentModifiers }) => {
  const { t } = useTranslation();
  const [methods] = useState([
    { id: 0, name: t('methodChooser.ownType'), description: t('methodChooser.ownTypeDescription') },
    {
      id: 1,
      name: t('methodChooser.digital'),
      description: t('methodChooser.digitalDescription'),
      deliveryType: 'EMAIL'
    },
    {
      id: 2,
      name: t('methodChooser.printed'),
      description: t('methodChooser.printedDescription'),
      deliveryType: 'POST'
    }
  ]);

  return (
    <div className={styles.chooserCard}>
      <div className={styles.chooserWrapper}>
        <RadioGroup value={selectedMethod || ''} onChange={(e) => onMethodChange(e.target.value)}>
          {methods.map((method) =>
            method.name === t('methodChooser.printed') || method.name === t('methodChooser.digital') ? (
              <Tooltip
                title={
                  method?.name === t('methodChooser.digital')
                    ? t('methodChooser.digitalTooltip')
                    : t('methodChooser.printedTooltip')
                }>
                {/* !shopTier?.printOption !shopTier?.digitalImageSending */}
                <div
                  className={
                    (method.name === t('methodChooser.printed') && !shopTier?.printOption) ||
                    (currentModifiers.some(
                      (modifier) => modifier.priority === 1 && modifier.deliveryTypeDTO === 'POST'
                    ) &&
                      method.name === t('methodChooser.printed'))
                      ? styles.methodCardDisabled
                      : (method.name === t('methodChooser.digital') && !shopTier?.digitalImageSending) ||
                        (currentModifiers.some(
                          (modifier) => modifier.priority === 1 && modifier.deliveryTypeDTO === 'EMAIL'
                        ) &&
                          method.name === t('methodChooser.digital'))
                      ? styles.methodCardDisabled
                      : selectedMethod === method?.id
                      ? styles.selectedMethod
                      : styles.methodCard
                  }
                  selected={selectedMethod.id === method?.id}
                  onClick={
                    (method.name === t('methodChooser.printed') && !shopTier?.printOption) ||
                    (currentModifiers.some(
                      (modifier) => modifier.priority === 1 && modifier.deliveryTypeDTO === 'POST'
                    ) &&
                      method.name === t('methodChooser.printed'))
                      ? () => {}
                      : (method.name === t('methodChooser.digital') && !shopTier?.digitalImageSending) ||
                        (currentModifiers.some(
                          (modifier) => modifier.priority === 1 && modifier.deliveryTypeDTO === 'EMAIL'
                        ) &&
                          method.name === t('methodChooser.digital'))
                      ? () => {}
                      : () => onMethodChange(method)
                  }
                  key={method?.id}>
                  <div className={styles.methodContent}>
                    <div className={styles.methodHeader}>
                      <div>
                        <div className={styles.methodName}>{method?.name}</div>
                        <div className={styles.methodDescription}>{method.description}</div>
                      </div>
                      {selectedMethod.id === method?.id ? (
                        <CheckIcon className={styles.checkIcon} />
                      ) : (
                        <Radio
                          disabled
                          checked={selectedMethod.id === method?.id}
                          value={method.id}
                          name='method-radio'
                          color='primary'
                          size='small'
                          sx={{
                            padding: 0,
                            margin: '-2px',
                            color: selectedMethod.id === method?.id ? '#FFB800' : '#D1D5DB'
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </Tooltip>
            ) : (
              <>
                <Tooltip title={t('methodChooser.ownTypeTooltip')}>
                  <div
                    className={selectedMethod === method?.id ? styles.selectedMethod : styles.methodCard}
                    key={method?.id}
                    selected={selectedMethod.id === method?.id}
                    onClick={() => onMethodChange(method)}>
                    <div className={styles.methodContent}>
                      <div className={styles.methodHeader}>
                        <div>
                          <div className={styles.methodName}>{method?.name}</div>
                          <div className={styles.methodDescription}>{method.description}</div>
                        </div>
                        {selectedMethod.id === method?.id ? (
                          <CheckIcon className={styles.checkIcon} />
                        ) : (
                          <Radio
                            disabled
                            checked={selectedMethod.id === method?.id}
                            value={method.id}
                            name='method-radio'
                            color='primary'
                            size='small'
                            sx={{
                              padding: 0,
                              margin: '-2px',
                              color: selectedMethod.id === method?.id ? '#FFB800' : '#D1D5DB'
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </Tooltip>
                {/* <Divider style={{ width: '95%', alignSelf: 'center' }} /> */}
                <p>{t('methodChooser.description')}</p>
              </>
            )
          )}
        </RadioGroup>
      </div>
    </div>
  );
};

export default MethodChooser;
